import {put} from "../util/http.service";

export const updateSettingsGeneral = settings => put("/settings/general", settings);
export const updateSettingsAccounts = settings => put("/settings/accounts", settings);
export const updateSettingsPortfolio = settings => put("/settings/portfolio", settings);
export const updateSettingsPortfolioFeature = settings => put("/settings/portfolio/feature", settings);
export const updateSettingsCars = settings => put("/settings/cars", settings);
export const updateSettingsCarsFeature = settings => put("/settings/cars/feature", settings);
